/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ExternalPageWrapperModule } from '../externalPageWrapper/external-page-wrapper.module';
import { LoadbalancerModule } from '../../modules/loadbalancer/loadbalancer.module';
import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../core/shared.module';
import { TwoFactorAuthApiService } from '../../core/http';

/**
 * Define dependencies
 */
@NgModule({
    imports: [
        SharedModule,
        ExternalPageWrapperModule,
        LoadbalancerModule
    ],
    declarations: [
        LoginComponent,
    ],
    providers: [
        TwoFactorAuthApiService
    ]
})

export class LoginModule {
}
